<template>
  <li>
    <span>3SPACE</span>
    <div class="header_hover_menu">
      <router-link to="/about">
        {{ $t("menu.3spaceSub.about") }}
      </router-link>
      <router-link to="/art-pool/pace2.0">
        $PACE
      </router-link>
      <a href="https://docs.3space.art" target="_blank">
        {{ $t("menu.3spaceSub.whitePaper") }}
      </a>
      <router-link to="/features">
        {{ $t("menu.3spaceSub.features") }}
      </router-link>
      <router-link to="/guide">
        {{ $t("menu.3spaceSub.guide") }}
      </router-link>
    </div>
  </li>
</template>

<script>
export default {
  name: "HeaderDropdownAbout",
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
